import React, { FC, ReactElement } from "react"
const Description: FC<{ children: string | ReactElement }> = ({ children }) =>
  typeof children === "string" ? <p>{children}</p> : children
export default Description
